var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllCoes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_186",
    "data-name": "Group 186",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.26,
    height: 92.854,
    viewBox: "0 0 124.26 92.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 105.886,
    height: 92.854,
    transform: "translate(0 0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(1.629 3.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M762.666,193.532c6.272-8.952,15.6-19.955,13.134-38.918-2.814-21.67-35.407-56.072-70.265-30.274-13.7,10.145-14.447,33.263-32.753,27.339s-30.623,40.071-3.123,46.034S750.765,210.525,762.666,193.532Z",
    transform: "translate(-653.573 -115.138)",
    fill: "#34c3ea",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 48.42,
    cy: 4.878,
    rx: 48.42,
    ry: 4.878,
    transform: "translate(14.209 79.359)",
    fill: "#34c3ea",
    opacity: 0.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_146",
    "data-name": "Group 146",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M708.2,807.576l1.909,2.456s-2.56,2.853-1.71,2.589,5.565-4.053,5.565-4.053-2.277-3.052-2.239-3.071C711.781,805.469,708.2,807.576,708.2,807.576Z",
    transform: "translate(-640.709 -729.084)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_147",
    "data-name": "Group 147",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M626.442,629.349l8.069,17.007-5.13,2.891L621,634.007l.529-5.008Z",
    transform: "translate(-561.748 -569.262)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_148",
    "data-name": "Group 148",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M899.6,682.976l6.037,20.71h.69L901.7,682.9Z",
    transform: "translate(-814.025 -618.07)",
    fill: "#cdd5d7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_149",
    "data-name": "Group 149",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M740.292,684.709,735.7,704.966h.813l6.141-20.266Z",
    transform: "translate(-665.611 -619.7)",
    fill: "#cdd5d7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_150",
    "data-name": "Group 150",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M841.2,679.8l.7,20.729h.964l.425-20.644Z",
    transform: "translate(-761.143 -615.263)",
    fill: "#cdd5d7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_151",
    "data-name": "Group 151",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M772.13,767.434,785.905,767l.095,1.427L771.1,769Z",
    transform: "translate(-697.666 -694.224)",
    fill: "#cdd5d7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_152",
    "data-name": "Group 152",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M727.405,390.1s-2.239-24.612.652-24.839,9.439-2.305,10.62,1.89c1.238,4.412-.435,27.986-2.1,27.759a49.524,49.524,0,0,0-8.777.076c-1.181.057-13.492,1.039-11.848-1.927.482-.869,2.4-1.219,3.241-1.455a49.052,49.052,0,0,1,4.819-1.02C724.2,390.568,727.4,390.086,727.405,390.1Z",
    transform: "translate(-647.594 -329.791)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M920.5,397.292c.009-.009.066.066.161.217a2.543,2.543,0,0,1,.161.293,4.158,4.158,0,0,1,.189.406,9.539,9.539,0,0,1,.68,2.806,35.484,35.484,0,0,1,.114,4.271c-.029,1.606-.123,3.363-.265,5.206s-.321,3.6-.491,5.187-.331,3.033-.548,4.223a18.3,18.3,0,0,1-.718,2.787,4.426,4.426,0,0,1-.425.964,8.055,8.055,0,0,1,.274-1.011,23.963,23.963,0,0,0,.586-2.787c.189-1.19.321-2.617.463-4.214s.312-3.345.454-5.187.255-3.59.3-5.187a41.156,41.156,0,0,0-.028-4.233,10.988,10.988,0,0,0-.548-2.778C920.655,397.632,920.476,397.3,920.5,397.292Z",
    transform: "translate(-831.915 -359.446)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_154",
    "data-name": "Group 154",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M559.968,480.527l-.718-.387a8.08,8.08,0,0,1-1.219-.624,2.353,2.353,0,0,1-.52-.444,3.246,3.246,0,0,1-.491-.69c-.1-.236-.425-.255-.482-.038a2.313,2.313,0,0,0,.813,1.474c.6.6-.671.416-1.134.359a7.772,7.772,0,0,0-2.022-.038c-.17.189.019.425.482.472s1.861.283,1.842.52-2.39-.085-2.39-.085-.5-.151-.539.132c-.057.5,2.466.661,2.712.671a.129.129,0,1,1-.029.255c-.189-.019-2.362-.378-2.419.132-.047.387,2.079.151,2.513.472s-1.644.019-1.672.4c-.009.142,0,.246,1.2.255,1.228,0,4.526-.529,4.526-.529l-.472-2.334",
    transform: "translate(-500.707 -432.704)",
    fill: "#ffba98"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M621.385,398.3s-6.2,8.324-7.615,8.7-9.543.86-9.543.86l-.727,3.515s10.4.548,12.689-1.143c3.6-2.655,7.379-8.768,7.379-8.768C623.662,399.453,622.888,398.442,621.385,398.3Z",
    transform: "translate(-545.901 -360.359)",
    fill: "#ffbe55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M590.31,859.7l.4,3.09s-3.656,1.153-2.787,1.36,6.859-.652,6.859-.652-.406-3.779-.359-3.779S590.31,859.7,590.31,859.7Z",
    transform: "translate(-531.672 -778.165)",
    fill: "#0e538c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_157",
    "data-name": "Group 157",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M813.582,563.1s3.448,7.379-3.354,9.911l-3.628-7.9Z",
    transform: "translate(-729.812 -509.589)",
    fill: "#0e538c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M612.378,558.137s-19.652-5.395-21.863-.869.416,28.137.416,28.137l6.151-.642s-1.02-20.72,0-21.447,15.183,2.853,16.667,2.787C617.376,565.932,619.937,559.177,612.378,558.137Z",
    transform: "translate(-533.341 -502.671)",
    fill: "#0e538c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M764.713,374.157a4.912,4.912,0,0,0-4.8,4.677c-.094,2.145.113,5.083-.473,7.672-.3,1.332-2.041,6.7-2.041,6.7l1.748.293a19.047,19.047,0,0,0,8.1-.4l1.984-.539s1.143-5.962,1.8-11.565c.538-4.677-.35-6.5-3.194-6.9Z",
    transform: "translate(-685.26 -338.446)",
    fill: "#ffbe55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M802.427,268.008a19.016,19.016,0,0,0-.057-2.362,2.068,2.068,0,0,1-1.8-1.946c-.066-1.729.123-5.716.123-5.716l3.2-1.483,3.439,2.721.312,1.909-.794,2.268-.359,4.327Z",
    transform: "translate(-724.335 -231.957)",
    fill: "#ffe3ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M819.8,346.227a4.3,4.3,0,0,0,2.305-.727,2.241,2.241,0,0,1-2.277,1.153Z",
    transform: "translate(-741.765 -312.548)",
    fill: "#fcd2b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M726.528,557.49l-.812-.047a7.139,7.139,0,0,1-1.37-.057,2.041,2.041,0,0,1-.661-.189,3.145,3.145,0,0,1-.737-.425c-.189-.179-.5-.057-.453.161a2.336,2.336,0,0,0,1.36,1c.8.284-.435.661-.879.8a7.614,7.614,0,0,0-1.852.812c-.076.246.189.378.633.227s1.8-.529,1.89-.293-2.2.926-2.2.926-.52.076-.435.34c.161.482,2.513-.435,2.74-.529.151-.066.255.18.085.246s-2.3.652-2.145,1.143c.123.378,1.946-.737,2.475-.624s-1.483.709-1.361,1.058c.047.132.1.227,1.2-.274a43.471,43.471,0,0,0,3.883-2.381l-1.408-1.918",
    transform: "translate(-652.3 -503.78)",
    fill: "#ffe3ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M805.7,447.993a17.99,17.99,0,0,0,6.321-3.392,5.2,5.2,0,0,0,1.927-3.515l.926-7.086Z",
    transform: "translate(-728.997 -392.686)",
    opacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M773.316,377.483s-.737,10.355-1.738,11.432S764,394.783,764,394.783l1.285,3.354s9.061-5.14,10.081-7.795c1.228-3.212,1.455-8.2,1.493-10.336a2.922,2.922,0,0,0-1.058-2.343A2.127,2.127,0,0,0,773.316,377.483Z",
    transform: "translate(-691.237 -341.225)",
    fill: "#ffbe55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M800.98,667.94c-.038.113-2.693-.17-5.99-.349s-5.99-.2-5.99-.321a29.778,29.778,0,0,1,6.047-.085A28.8,28.8,0,0,1,800.98,667.94Z",
    transform: "translate(-713.875 -603.762)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(0 0)",
    opacity: 0.05,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M780.915,415.2a2.207,2.207,0,0,1,.038.671c0,.435-.009,1.058-.066,1.824a17.074,17.074,0,0,1-.387,2.693,9.642,9.642,0,0,1-1.266,3.1,10.516,10.516,0,0,1-2.315,2.419c-.8.633-1.568,1.143-2.2,1.578-1.276.86-1.994,1.465-2.031,1.427-.019-.019.142-.2.463-.491s.8-.69,1.417-1.143,1.36-.992,2.145-1.625a10.675,10.675,0,0,0,2.22-2.362,9.67,9.67,0,0,0,1.247-2.976,19.562,19.562,0,0,0,.453-2.636A22.6,22.6,0,0,1,780.915,415.2Z",
    transform: "translate(-699.1 -375.662)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M836.6,361.8l.142-1.54,2.5-.463.756,1.644Z",
    transform: "translate(-756.977 -325.497)",
    fill: "#ffbe55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M817.265,360.074l.992.189v1.54L817,361.548l.312-1.748",
    transform: "translate(-739.229 -325.497)",
    fill: "#ffbe55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 63.303,
    height: 2.069,
    transform: "translate(36.293 52.67)",
    fill: "#2a94f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M382.951,576.1,378,607.232l2.475.047,8.494-31.179Z",
    transform: "translate(-341.707 -521.361)",
    fill: "#2a94f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M941.88,563.264l2.891,32.124h-2.315L936.231,564.6l-.331-2.3,5.981.964",
    transform: "translate(-846.895 -508.865)",
    fill: "#2a94f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_172",
    "data-name": "Group 172",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M937.9,576.1l.227,1.436,5.707-.217-.113-1.219Z",
    transform: "translate(-848.706 -521.361)",
    fill: "#0e538c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M428.136,576.1l-.236,1.464,5.905-.161.35-1.3Z",
    transform: "translate(-386.892 -521.361)",
    fill: "#0e538c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M478.3,432.2l3.949,11.527h17.857l-.132-.6-7.228-.217L489.421,432.2Z",
    transform: "translate(-432.53 -391.057)",
    fill: "#f7f7f7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_175",
    "data-name": "Group 175",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M549.027,482.615a.817.817,0,0,1-.453,1.03.79.79,0,0,1-.879-.68.817.817,0,0,1,.453-1.03A.8.8,0,0,1,549.027,482.615Z",
    transform: "translate(-495.34 -436.076)",
    fill: "#d3d3d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176",
    "data-name": "Group 176",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M917.311,440.836a34.176,34.176,0,0,1-.907-6.2,2.52,2.52,0,0,1,.085-1.1.94.94,0,0,1,.822-.642.924.924,0,0,1,.737.491,2.572,2.572,0,0,1,.274.879c.34,1.738.68,3.467,1.02,5.206a6.335,6.335,0,0,1,1.257-1.653c.227-.217.557-.425.831-.274.246.132.274.472.264.756a14.281,14.281,0,0,1-.321,2.532",
    transform: "translate(-829.223 -391.69)",
    fill: "#ffbe55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M917.571,515s-.888,3.534,2.712,3.694C923.6,518.845,922.8,515,922.8,515Z",
    transform: "translate(-830.21 -466.033)",
    fill: "#0e538c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M824.5,287.555a.428.428,0,0,1,.076.038,1.358,1.358,0,0,1,.208.151,1.371,1.371,0,0,1,.4,1.446,1.49,1.49,0,0,1-.4.624,1.523,1.523,0,0,1-.34.227,1.45,1.45,0,0,1-.406.123,1.376,1.376,0,0,1-.86-.151,1.4,1.4,0,0,1-.6-.642,1.26,1.26,0,0,1-.123-.406,1.461,1.461,0,0,1,0-.406,1.416,1.416,0,0,1,.3-.671,1.372,1.372,0,0,1,1.427-.453,1,1,0,0,1,.236.094c.047.009.076.019.076.028a2.2,2.2,0,0,0-.321-.1,1.357,1.357,0,0,0-.879.085,1.208,1.208,0,0,0-.482.378,1.425,1.425,0,0,0-.284.642,1.269,1.269,0,0,0,0,.378,1.342,1.342,0,0,0,.68.983,1.367,1.367,0,0,0,.813.151,1.379,1.379,0,0,0,.7-.321,1.354,1.354,0,0,0,.444-1.2,1.362,1.362,0,0,0-.406-.784A2.049,2.049,0,0,0,824.5,287.555Z",
    transform: "translate(-744.164 -259.923)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M789.338,286.074h.085a.969.969,0,0,1,.245.038,1.4,1.4,0,0,1,.756.52,1.415,1.415,0,0,1,.246.6,1.345,1.345,0,0,1-.085.737,1.286,1.286,0,0,1-.2.35,1.12,1.12,0,0,1-.312.283,1.375,1.375,0,0,1-.841.246,1.412,1.412,0,0,1-.822-.3,1.12,1.12,0,0,1-.283-.312,1.425,1.425,0,0,1-.179-.359,1.316,1.316,0,0,1-.028-.737,1.377,1.377,0,0,1,.283-.576,1.449,1.449,0,0,1,.784-.472.85.85,0,0,1,.255-.019.772.772,0,0,0,.094.009c0,.009-.123,0-.331.047a1.312,1.312,0,0,0-.746.472,1.453,1.453,0,0,0-.265.557,1.269,1.269,0,0,0,.038.7,1.147,1.147,0,0,0,.17.34,1.327,1.327,0,0,0,1.049.576,1.366,1.366,0,0,0,.793-.227,1.351,1.351,0,0,0,.293-.274,1.067,1.067,0,0,0,.189-.331,1.377,1.377,0,0,0,.085-.7,1.419,1.419,0,0,0-.227-.576,1.318,1.318,0,0,0-.718-.52C789.461,286.083,789.338,286.083,789.338,286.074Z",
    transform: "translate(-712.862 -258.725)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M816.8,302a.567.567,0,0,1,.293-.028.714.714,0,0,1,.293.047.567.567,0,0,1-.293.028C816.932,302.051,816.8,302.032,816.8,302Z",
    transform: "translate(-739.048 -273.134)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M851.1,303.283a3.608,3.608,0,0,1,.708-.019,3.116,3.116,0,0,1,.709.066,3.62,3.62,0,0,1-.709.019A2.525,2.525,0,0,1,851.1,303.283Z",
    transform: "translate(-770.108 -274.3)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M807.322,261.487a5.657,5.657,0,0,0,1.03-3.855,3.674,3.674,0,0,0-.359-1.918,3.091,3.091,0,0,0-1.5-1.172,5.145,5.145,0,0,0-2.91-.4,3.431,3.431,0,0,0-2.381,1.625,46.521,46.521,0,0,1,4.8.085c.293.179,1.228.831,1.153,1.625s-.3,1.984-.3,1.984l.727-.113s-.057-1.1.255-1.058S807.322,261.487,807.322,261.487Z",
    transform: "translate(-724.922 -229.763)",
    fill: "#0b4870"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M868.2,299.322a.319.319,0,0,0,.3.208.583.583,0,0,0,.359-.151,1.074,1.074,0,0,0,.425-.68.721.721,0,0,0-.321-.709.548.548,0,0,0-.728.161Z",
    transform: "translate(-785.592 -269.46)",
    fill: "#ffe3ca"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCoes);
export default __webpack_public_path__ + "static/media/all-coes.1229f50b0df8f4b8c486d3ea0981a809.svg";
export { ForwardRef as ReactComponent };